import React from 'react';
import SVGUniqueID from 'react-svg-unique-id';

import { SVGComponentProps } from '../types';

function ChevronRightArrowIcon(props: SVGComponentProps) {
  const { width = 20, height = 20, fill = '#475569' } = props;
  return (
    <SVGUniqueID>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        fill={fill}
        viewBox="0 0 20 20"
      >
        <path
          fillRule="evenodd"
          d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
          clipRule="evenodd"
        />
      </svg>
    </SVGUniqueID>
  );
}

export { ChevronRightArrowIcon };
